module.exports = __webpack_public_path__ + "img/skip-start.c7be495e.svg";